import React, { PropTypes } from 'react';
import classNames from 'classnames';

const Option = (props) => {
    const { option, widget } = props;
    let input;
    const optionCss = classNames({
        'choice__option': true,
        'choice__option--radio': (widget.type === 'Single Choice'),
        'choice__option--checkbox': (widget.type === 'Multiple Choice'),
    });

    if ((widget.type === 'Single Choice')) {
        input = <input type="radio" id={`widget-${widget.id}-${option.id}`} name={`radio-group-${widget.id}`} onChange={(e) => e.preventDefault()} checked={option.checked} />;
    } else {
        input = <input type="checkbox" id={`widget-${widget.id}-${option.id}`} name={`checkbox-group-${widget.id}`} onChange={(e) => e.preventDefault()} checked={option.checked} />;
    }

    return (
        <div className={optionCss} data-id={option.id}>
            <label htmlFor={`widget-${widget.id}-${option.id}`} onClick={(e) => e.preventDefault()}>
                { input }
                { (option.checked) ? <span className="choice__icon -active" /> : <span className="choice__icon" /> }
                <span className="choice__label">{option.label}</span>
            </label>
        </div>
    );
};

Option.propTypes = {
    option: PropTypes.shape({
        id: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
        checked: PropTypes.bool.isRequired,
    }).isRequired,
    widget: PropTypes.object.isRequired,
};

export default Option;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/Widgets/Choice/Option.jsx